import { createReducer, on } from '@ngrx/store';

import * as uiPreferencesActions from '../actions/ui-preferences.actions';
import { uiPreferencesInitialState } from '../states/ui-preferences.state';

export const UI_PREFERENCES_REDUCER_KEY = 'uiPreferences';

export const UI_PREFERENCES_REDUCER = createReducer(
    uiPreferencesInitialState,

    on(uiPreferencesActions.SetUiPreferences, (state, action) => ({
        ...state,
        preferences: action.preferences,
        loaded: true,
        error: null,
    })),

    on(uiPreferencesActions.SaveUiPreferencesSuccess, (state, action) => ({
        ...state,
        preferences: action.preferences,
        loaded: true,
        error: null,
    })),

    on(uiPreferencesActions.DeleteUiPreferencesSuccess, state => ({
        ...state,
        preferences: null,
        loaded: true,
        error: null,
    })),

    on(uiPreferencesActions.SetUiPreferencesLoading, (state, action) => ({
        ...state,
        loading: action.loading,
    })),

    on(uiPreferencesActions.SetUiPreferencesError, (state, action) => ({
        ...state,
        error: action.error,
        loading: false,
    }))
);
